<template>
    <router-link :to="to" class="d-flex flex-column align-center">
        <v-icon size="large">mdi-star</v-icon>
        <span v-if="show">{{title}}</span>
    </router-link>
</template>
<script>
export default {
    name:'AccountIcon',
    props:{
        title: String,
        to: {
            type: [String, Object]
        },
        show:{
            type: Boolean,
            default: true
        }
    }
}
</script>
<style lang="scss" scoped>
a{
    position: relative;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    margin: 0 8px;
    justify-content: center;
    text-align: center;
    height: 58px;
    color: #000;
    font-size: 14px;
    line-height: 17px;
    i{
        margin-bottom: 6px;
    }
    span{
        display: inline-block;
        
        border-radius: 12px;
        padding: 0 0;
    }
}
</style>